/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

